import { render, staticRenderFns } from "./titleCom.vue?vue&type=template&id=57c0fff8&scoped=true"
import script from "./titleCom.vue?vue&type=script&lang=js"
export * from "./titleCom.vue?vue&type=script&lang=js"
import style0 from "./titleCom.vue?vue&type=style&index=0&id=57c0fff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0fff8",
  null
  
)

export default component.exports